import { useInstance } from '../../support/ioc/useInstance';
import { useEffect } from 'react';
import { PreMissionWeatherState } from '../PreMissionWeatherState.ts';

export const ClearPreMissionWeatherState: React.FC = () => {
    const state = useInstance(PreMissionWeatherState);
    useEffect(() => {
        state.reset();
    },  [state]);
    return null;
};
